import {axios} from "@/utils"

const endpoints = {
    get_medias: '/v3/medias/',
}

export default {
    async getMedias(params) {
        const response = await axios.get(endpoints.get_medias, {params})
        return response.data
    },
}